import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import ParametersSecurity from "go-security/services";

const SecurityProfileChangePasswordPage: FC<RouteComponentProps> = () => {
	const { t } = useTranslation();

	return (
		<div className="content">
			<div className="content-header">
				<h1>{t("lib:go_component.profile.change_password.header.title")}</h1>
			</div>
			<div>
				<a
					target="_blank"
					rel="noreferrer"
					href={`${ParametersSecurity.getAccountsUrl()}/profile/change_password`}
				>
					{t("lib:go_component.profile.change_password.actions.change_password")}
				</a>
			</div>
		</div>
	);
};

export default SecurityProfileChangePasswordPage;
